import { Components } from '@mui/material';

export const tooltipsConfigs: Components['MuiTooltip'] = {
  defaultProps: {
    enterTouchDelay: 100,
  },
};
